"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var allowedAliasCharacters = exports.allowedAliasCharacters = "\\w\\-\\_\\+\\*\\(\\)\\!#&åô’çéãí“”,";
var startOfURL = exports.startOfURL = "https?\\S*";

function getAliasesRegex() {
  return new RegExp("(" + startOfURL + ")?:([" + allowedAliasCharacters + "]+):", "g");
}

exports.default = getAliasesRegex;